// labRequestGeneralStatusCategory: Categories for lab request tabs in LabCitec tables (e.g., "En progreso", "Rechazada")
export const labRequestGeneralStatusCategory = {
    // Represents lab requests that are currently in progress,
    // this category usually includes lab requests with requestStatus:
    // - "En Espera"
    // - "Pendiente de envío"
    // - "Aceptada"
    // Check the backend services for the exact logic
    inProgress: 'En proceso',
    // Represents lab requests that have been rejected (requestStatus: "Rechazada")
    rejected: 'Rechazada',
}

// labRequestGeneralStatus: Possible values for the 'generalStatus' field (matches the 'generalStatus' column in the database)
export const labRequestGeneralStatus = {
    completed: 'Concluida',
    cancelled: 'Cancelada',
}

// labRequestStatus: Possible values for the 'requestStatus' field (matches the 'requestStatus' column in the database)
export const labRequestStatus = {
    pending: 'Pendiente de envío',
    accepted: 'Aceptada',
    rejected: 'Rechazada',
    completed: 'Concluida',
    waiting: 'En Espera',
    cancelled: 'Cancelada',
}